import React from 'react'
import MenuNavbar from '../function-components/MenuNavbar';
import Floaticons from '../function-components/Floaticons';
import './CyberHER.css'
import Link from '@mui/material/Link';
import HomeIcon from '@mui/icons-material/Home';
import { Breadcrumbs } from "@material-ui/core";
import Typography from '@mui/material/Typography';

function CyberHER() {
    return (
        <>
            <div className="banner-container">
                <img src="images/Banner1.png" alt="banner" className="banner-img" />
                <div className="breadcrumbs-container">
                    <Breadcrumbs separator=">" color="#fff">
                        <Link
                            underline="hover"
                            sx={{ display: 'flex', alignItems: 'center' }}
                            color="#fff"
                            href="/"
                        >
                            <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        </Link>,
                        <Link
                            underline="hover"
                            key="2"
                            color="#fff"
                            href="/KeyInitiatives"
                        // onClick={handleClick}
                        >
                            Key Initiatives
                        </Link>,
                        <Typography key="3" color="#fff">
                            CyberHER
                        </Typography>,
                    </Breadcrumbs>
                </div>
                <MenuNavbar />
            </div>
            <Floaticons />
            {/* section 1 */}
            <div className="cybercontent">
                <p className="cyberpara">
                    This an opportunity for women employees to learn application security concepts to develop secure software and help us on our mission to SECURE THE WORLD!
                </p>
                {/* <a href="#">Click Here to Visit Portal</a> */}
            </div>

            {/* section2 */}
            <div className='journeycontent'>
                <div className='journey'>
                    <h2>How to Journey Unfolds...</h2>
                    <img src='images/Learning-Journey.png' className='journey-img'></img>
                </div>
            </div>

            {/* section 3 */}

            {/* <div className='uniquecontent'>
                <div className='unique'>
                    <img src='images/unique.png' className='unique-img'></img>
                </div>
            </div> */}

            <div className="program-design-container">
                <div className="program-design-wrap">
                    <h2>Program Design</h2>
                    <div className="program-design-row">
                        <div className="program-design-box">
                            <img src="images/Program-Design-infographic.png" alt="Program-design" />
                        </div>
                    </div>
                </div>
            </div>

            {/* section 4  */}
            <div className="domain-container">
                <div className="domain-wrap">
                    <h2>Secure Software Lifecycle - Domains</h2>
                    <div className="domain-row">
                        <div className="domain-box">
                            <img src="images/Enablers.png" alt="domain-icon" />
                            <h3>Enablers</h3>
                            <ul>
                                <li>Learning Guides</li>
                                <li>Exam Prep guides</li>
                                <li>SME Connects</li>
                                <li>Mock Assessment platform</li>
                            </ul>
                        </div>
                        <div className="domain-box">
                            <img src="images/Exam.png" alt="domain-icon" />
                            <h3>Exam</h3>
                            <ul>
                                <li>Take the exam as per myCompetency guidelines</li>
                                <li>Achieve proficiency on Application Security Fundamentals skill</li>
                            </ul>
                        </div>
                        <div className="domain-box">
                            <img src="images/Other-Actions.png" alt="domain-icon" />
                            <h3>Other Actions</h3>
                            <ul>
                                <li>Register for the CyberHER assessment</li>
                            </ul>
                        </div>
                        <div className="domain-box">
                            <img src="images/Next-Steps.png" alt="domain-icon" />
                            <h3>Next Steps</h3>
                            <ul>
                                <li>Share your success story with peers and colleagues</li>
                                <li>Receive CyberHer program certificate and CyberHER flair</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* section 5  */}
            <div className="secure-container">
                <div className="secure-wrap">
                    <div className="secure-row">
                        <div className="secure-box">
                            <a href="https://app.pluralsight.com/library/courses/secure-software-concepts-csslp/table-of-contents" target='_blank'>Secure Software Concepts</a> <br />
                            <a href="https://app.pluralsight.com/library/courses/secure-software-requirements-csslp/table-of-contents" target='_blank'>Secure Software Requirements</a><br />
                            <a href="">Secure Software Architecture and Design</a>
                        </div>
                        <div className="secure-box">
                            <a href="" target='_blank'>Secure Software Implementation</a><br />
                            <a href="" target='_blank'>Secure Software Testing</a><br />
                            <a href="https://app.pluralsight.com/library/courses/secure-software-lifecycle-management-csslp/table-of-contents" target='_blank'>Secure Software Lifecycle Management</a>
                        </div>
                        <div className="secure-box">
                            <a href="https://app.pluralsight.com/library/courses/secure-software-deployment-ops-maintenance-csslp/table-of-contents" target='_blank'>Secure Software Deployment, Operations, and Maintenance</a><br />
                            <a href="https://app.pluralsight.com/library/courses/secure-software-supply-chain-csslp/table-of-contents" target='_blank'>Secure Software Supply Chain</a>
                        </div>
                    </div>
                </div>
            </div>

            {/* section 6 */}

            <div className='journeycontent'>
                <div className='journey'>
                    <img src='images/journeypath.png' className='journey-img'></img>
                </div>
            </div>

        </>
    )
}

export default CyberHER;